import script from "./Categories.vue?vue&type=script&lang=ts&setup=true"
export * from "./Categories.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__